<script setup>
import { Warning } from '@element-plus/icons-vue';
</script>

<template>
  <section>
    <el-tooltip
      :disabled="!isOutdated"
      class="item"
      popper-class="tooltip"
      effect="dark"
      placement="bottom"
      :content="`Data is at least ${maxDaysOld} days old.<br>Is there an issue with the data scraper?`"
      raw-content
    >
      <span>{{ updatedAt && fullDate }}<el-icon v-if="isOutdated" class="warning"><Warning /></el-icon></span>
    </el-tooltip>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'DataDescription',
  data() {
    return {
      maxDaysOld: 2,
    };
  },
  computed: {
    ...mapGetters({ updatedAt: 'game/updatedAt' }),
    fullDate() {
      let minutes = this.updatedAt.getMinutes() < 10 ? '0' : '';

      minutes += this.updatedAt.getMinutes().toString();

      return `${this.updatedAt.toDateString()}, ${this.updatedAt.getHours()}h${minutes}`;
    },
    isOutdated() {
      // don't display the icon if the data is loading
      if (!this.updatedAt) return false;

      const outdatedLimit = 60 * 60 * 24 * this.maxDaysOld;
      const now = new Date();

      return ((now - this.updatedAt) / 1000) > outdatedLimit;
    },
  },
};
</script>

<style scoped>
section {
  text-align: center;
}

.warning {
  color: #E6A23C; /* --color-warning */
  margin-left: 4px;
}
</style>
